export const LogoSymbol = ({ size = 40, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true" className={className}>
    <rect width="64" height="64" rx="18" fill="#2F6B6A" />
    <circle cx="47" cy="17" r="4" fill="#A7B8A0" />
    <text x="32" y="46" textAnchor="middle" fontFamily="Fraunces, Georgia, serif" fontStyle="italic" fontSize="40" fill="#F7F2EA">&amp;</text>
  </svg>
);

export const Wordmark = ({ className = "", tone = "dark" }) => (
  <span className={`font-serif text-[1.35rem] leading-none tracking-tight ${tone === "dark" ? "text-ink" : "text-cream"} ${className}`}>
    Addiction <span className="italic text-clay text-[1.15em] font-medium">&amp;</span> Us
  </span>
);

export const Logo = ({ tone = "dark" }) => (
  <span className="inline-flex items-center gap-3">
    <LogoSymbol size={38} />
    <Wordmark tone={tone} />
  </span>
);
